function getUtmParams() {
  const urlParams = new URLSearchParams(window.location.search);
  const utms = {};
  for (const [key, value] of urlParams.entries()) {
    if (key.startsWith("utm_")) utms[key] = value;
  }
  return utms;
}

function getPartnerName() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get("partner_name") || urlParams.get("partner") || "none";
}

function getSource() {
  return getPartnerName() !== "none" ? "partner" : "main";
}

export const trackEvent = (eventName, params = {}) => {
  try {
    const baseParams = {
      page_location: window.location.href,
      session_id: window.sessionId || null,
      partner_name: getPartnerName(),
      source: getSource(),
      ...getUtmParams(),
      ...params,
    };

    if (typeof window.gtag === "function") {
      window.gtag("event", eventName, baseParams);
    }

    if (typeof window.ym === "function") {
      window.ym(96877951, "reachGoal", eventName, baseParams);
    }
  } catch (err) {
    console.warn("[Analytics Error]", err);
  }
};
